import { enumBranchStyle } from "../constants";

export function IsPeerStyle(branchStyle) {
  var peerStyle = false;
  switch (branchStyle) {
    case enumBranchStyle.assistantpeerleft:
    case enumBranchStyle.assistantpeerright:
      peerStyle = true;
      break;
  }

  return peerStyle;
}
